import store from '@/store'
import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { useLambda } from '@/views/habit/awsLambda'
import { oid, date } from '@/helpers/mongoHelpers'

export default function usePhysicalLocationAdd() {
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { router } = useRouter()
  const { createItem } = useLambda()
  const userData = store.state?.userStore?.userData
  const physical_location = ref({})
  const isSubmitting = ref(false)
  const collection = 'physical_location'

  const create = async (data) => {
    isSubmitting.value = true

    const payload = {
      client_id: oid(userData.client.$oid),
      name: data.name?.value || '',
      locationLeads: data.locationLeads?.value ? data.locationLeads?.value.map(e => oid(e)) : []
    }

    try {
      await createItem({ collection, payload })
      showSuccessMessage(i18n.t('message.physical_location_added'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.physical_location_add_error'))
    } finally {
      router.push({ name: 'organization-physical_location-list' })
      isSubmitting.value = false
    }
  }

  return {
    create,
    physical_location,
    isSubmitting,
  }
}
